/**
 * @generated SignedSource<<cce1804fdef0b42eb3a31531aed52f55>>
 * @relayHash 050c4c1a18ae3e6423b1092f20b0a143
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchJqlInput = {
  jql: string;
  viewId: string;
};
export type setJqlMutation$variables = {
  input: JiraSetIssueSearchJqlInput;
};
export type setJqlMutation$data = {
  readonly jira_setIssueSearchJql: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type setJqlMutation = {
  response: setJqlMutation$data;
  variables: setJqlMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "setJqlMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchJqlPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchJql",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setJqlMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchJqlPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchJql",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9740d3bdc782b2bd679b29fe3690aa38460f5633d020ea9c91f52f6308c116a5",
    "metadata": {},
    "name": "setJqlMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3c85daac11a42bc3abe49021df8b3785";

export default node;
